/*#__PURE__*/ export default {"key":"palette.ACCOUNT","type":"root","items":[]};